<template lang="html">
  <div class="container">

    <div class="header">
      <p class="test1">{{data.name}}</p>
      <p class="test2">
        <span>{{data.dname}}</span>
        <span>{{data.oname}}</span>
      </p>
      <img :src="getSrc()" alt="" >
    </div>


    <ul>

      <!-- <li @click="">
        <i class="icon-xingming iconfont yel"></i>
        <span>个人信息</span>
      </li> -->
  <!-- 我的任务先暂时隐藏 -->
      <!-- <li @click="$router.push({name:'mission'})" v-if="role1!='sale'">
        <i class="icon-renwu- iconfont bul"></i>
        <span>我的任务</span>
        <i class="icon-dropdown down"></i>
      </li> -->
      <!-- <li @click="$router.push({name:'examine'})">
       <img src="../assets/img/check.png" class="startimg" />
        <span>我的审核</span>
        <i class="icon-dropdown down"></i>
        <span class="show-number" v-if="reviewNoteNum">{{reviewNoteNum}}</span>

      </li> -->
      <li @click="$router.push({name:'news'})" >
        <i class="icon-xiaoxi iconfont red"></i>
        <span>我的消息</span>
        <i class="icon-dropdown down1"></i>
        <span class="show-number" v-if="newNoteNum">{{newNoteNum}}</span>
      </li>

      <!-- <li>
        <i class="icon-wodeshoucang iconfont yel"></i>
        <span>我的收藏</span>
        <i class="icon-dropdown down"></i>
      </li> -->

      <!-- <li>
        <i class="icon-qingchu iconfont green"></i>
        <span>清除缓存</span>
        <i class="icon-dropdown down"></i>
      </li> -->

      <!-- <li @click="$router.push({name:'case'})">
        <i class="icon-loupan iconfont yel"></i>
        <span>案例大全</span>
      </li> -->
      <li @click="getCaseUrl">
        <i class="icon-loupan iconfont yel"></i>
        <span>案例大全</span>
      </li>
      <li @click="$router.push({name:'ticketlist'})">
       <img src="../assets/img/start.png" class="startimg"/>
        <span>开票申请</span>
        <i class="icon-dropdown down"></i>
      </li>
      <li @click="$router.push({name:'knowledge'})">
        <i class="icon-shu iconfont  bul"></i>
        <span>知识库</span>
        <i class="icon-dropdown down"></i>
        <span class="show-number" v-if="noteNum">{{noteNum}}</span>
      </li>
      <li @click="$router.push({name:'fusion'})">
         <img src="../assets/img/fusion.png" class="startimg"/>
        <span>两化融合</span>
        <i class="icon-dropdown down"></i>
      </li>
      <li @click="$router.push({name:'buglist'})">
        <i class="icon-xingming iconfont yel"></i>
        <!-- 显示bug的条数 -->
        <span class="show-number show-number1" v-if="bugNoteNum">{{bugNoteNum}}</span>
        <span>bug反馈</span>
      </li>

      <!-- <li @click="wxsaoma" v-if="uid=='223'||uid=='84'">
        <i class="icon-shu iconfont  bul"></i>
        <span>扫一扫</span>
        <i class="icon-dropdown down"></i>
      </li> -->
      <!-- 关联项目 -->
      <li @click="relatedPro">
        <img src="../assets/img/关注项目.png" class="startimg"/>
        <span>项目关注</span>
        <i class="icon-dropdown down"></i>
      </li>
      <!-- 关联项目 -->

    </ul>


    <p  class="back" @click="logout">退出登录</p>

  </div>
</template>

<script>
  export default {
    data () {
      return {
        data: [],
        uid: '',
        newNoteNum: '',
        noteNum: '',//知识库
        bugNoteNum: '',//意见反馈的条数
        reviewNoteNum: '',//审核数量

      }
    },
    methods: {
      // 获取案例大全url
      getCaseUrl () {

        this.$http.getCaseUrl({}).then(res => {
          if (res.errCode == 0) {
            this.windowOpen(res.url)
          } else {
            this.$router.push({ name: 'case' })
          }
        })
      },
      relatedPro(){//关联项目
        this.$router.push({name:'relatedproject'})
      },
      windowOpen (url) {
        window.location.href = url
      },
      wxsaoma () {
        // console.log(this.uid)
        //点击按钮扫描二维码

        wx.scanQRCode({
          needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
          scanType: ["qrCode"], // 可以指定扫二维码还是一维码，默认二者都有
          success: function (res) {
            var result = res.resultStr; // 当needResult 为 1 时，扫码返回的结果
            window.location.href = result;//因为我这边是扫描后有个链接，然后跳转到该页面
            console.log(result, "result")
            console.log(res, 'res')
          }
        });

        // wx.scanQRCode({
        //   needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
        //   scanType: ["qrCode","barCode"], // 可以指定扫二维码还是一维码，默认二者都有
        //   success: function (res) {
        //     var result = res.resultStr; // 当needResult 为 1 时，扫码返回的结果
        //     console.log(res.resultStr,'res.resultStr')
        //     console.log(res,'res')
        //
        //   }
        // });
      },
      getSrc () {
        let src = ''
        if (this.data.avatar_path == null) {
          src = require('../assets/img/logo.png')
        } else {
          src = this.data.avatar_path
        }
        return src
      },
      logout () {
        window.localStorage.removeItem('token')
        window.localStorage.removeItem('userId')
        window.localStorage.removeItem('departmentId')
        this.$router.push({ name: 'login' })
      },
    },
    created () {
      this.uid = window.localStorage.getItem('userId')//获取userId
      this.$http.getMyData().then(res => {
        this.data = res.data
      })
      this.departid = JSON.parse(window.localStorage.getItem('departmentId'))// 先获取departmentId，
      this.role1 = window.localStorage.getItem('role')
      // 获取未读消息
      // this.$http.getNoReadNum().then(res => {
      //   this.newNoteNum = res.data.newNoteNum == 0 ? '' : res.data.newNoteNum
      //   this.noteNum = res.data.noteNum == 0 ? '' : res.data.noteNum//知识库数量
      //   this.bugNoteNum = res.data.bugNoteNum == 0 ? '' : res.data.bugNoteNum//bug数量
      //   this.reviewNoteNum = res.data.reviewNoteNum == 0 ? '' : res.data.reviewNoteNum//未审核数量
      //   // 触发tab 获取最新消息
      //   this.$root.Bus.$emit('getNewNum')
      // })
      // //bug反馈的未读条数
      // this.$http.getBugNoReadNum({user_id:this.uid}).then(res=>{
      //             this.bugNum=res.data.count
      //          // 触发tab 获取最新bug反馈消息数量
      //   this.$root.Bus.$emit('getNewBugNum')
      //         })
    },


  }
</script>

<style lang="css" scoped>
  .container {
    width: 100%;
    background-color: #fff;
  }
  .header {
    width: 100%;
    text-align: center;
    font-size: 0.375rem;
    background-color: #fff;
    height: 3.125rem;
    position: relative;
    box-shadow: 1px -0.078125rem 0.15625rem 0.046875rem rgba(0, 0, 0, 0.2);
  }
  .header img {
    width: 1.875rem;
    height: 1.875rem;
    border-radius: 50%;
    /*border: 1px solid #fff;*/
    position: absolute;
    right: 0.6875rem;
    top: 0.65625rem;
  }
  .test1 {
    color: #333;
    font-size: 0.4375rem;
    text-align: left;
    width: 90%;
    margin-left: 10%;
    padding-top: 1.09375rem;
    font-family: PingFangSC-Regular;
    font-weight: 500;
  }
  .test2 {
    color: #949494;
    font-size: 0.34375rem;
    text-align: left;
    width: 90%;
    margin-left: 10%;
    padding-top: 0.3125rem;
    font-family: PingFangSC-Regular;
    font-weight: 500;
  }
  .test2 span:first-child {
    border-right: 1px solid #e9e9e9;
    display: inline-block;
    height: 0.375rem;
    padding-right: 1.5%;
    line-height: 0.375rem;
    margin-right: 1.5%;
  }
  .container nav {
    background-color: #fff;
    border-bottom: 1px solid #ccc;
  }

  .container ul {
    width: 100%;
    margin: auto;
    background: #fff;
    height: 100%;
    margin-top: 0.3125rem;
    box-shadow: -1px 0px 0.09375rem 0px rgba(0, 0, 0, 0.1);
    font-family: PingFangSC-Regular;
    font-weight: 500;
  }

  .container ul li {
    margin: auto;
    position: relative;
    width: 95%;
    background: #fff;
    height: 1.1875rem;
    color: #666666;
    font-size: 0.4375rem;
    line-height: 1.1875rem;
    border-bottom: 1px solid #ddd;
  }
  .container ul li:last-child {
    border-bottom: 0;
  }
  .iconfont {
    margin-left: 0.09375rem;
    font-size: 0.5rem;
  }
  .icon-xiaoxi {
    margin-left: 0px;
    font-size: 0.625rem;
  }
  .down {
    position: absolute;
    top: 30%;
    right: 5%;
    color: #5483d2;
    transform: rotate(-90deg);
  }
  .icon {
    margin: 0.25rem;
  }
  .back {
    color: #5483d2;
    position: absolute;
    /*bottom: 3.5625rem;*/
    bottom: 2.5625rem;
    width: 7.90625rem;
    height: 1rem;
    border: 1px solid;
    border-radius: 0.625rem;
    text-align: center;
    line-height: 1rem;
    font-size: 0.4375rem;
    left: 0;
    right: 0;
    margin: auto;
    background: #fff;
  }
  .yel {
    color: #f3c470;
  }
  .bul {
    color: #4faff1;
  }
  .red {
    color: #e66c66;
  }
  .green {
    color: #88bf67;
  }
  .startimg {
    width: 18px;
    height: 18px;
    margin-left: 0.08rem;
    margin-right: 0.02rem;
    position: relative;
    top: 3px;
  }
  .show-number {
    position: absolute;
    top: 4px;
    width: 20px;
    height: 20px;
    line-height: 20px;
    border-radius: 10px;
    text-align: center;
    background: #f00;
    color: #fff;
    font-size: 12px;
  }
  .show-number1 {
    left: 26%;
  }
</style>



// WEBPACK FOOTER //
// src/components/My.vue